import { DataBean } from "../DataBean";

export class ProductionPlanItem extends DataBean {



    public async getProductionPlanItemCatalog(idProductionPlan: any, productionPlanDate: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProductionPlanItemCatalog_Number_java.util.Date_Number_Number", [idProductionPlan, productionPlanDate, page, recordsPerPage]);
    }

    public async addProductionPlanItem(idProductionPlan: any, productionPlanDate: any, productionItemDate: any, plannedQuantity: any, realQuantity: any, observations: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.productionorders.ProductionPlanItem_addProductionPlanItem_Number_java.util.Date_java.util.Date_Number_Number_String", [idProductionPlan, productionPlanDate, productionItemDate, plannedQuantity, realQuantity, observations]);
    }
}